const valueOr = (result, fallback) =>
  result?.status === "fulfilled" ? result.value : fallback;

export const resolveChairpersonDashboardRequests = (results = []) => {
  const [
    membersResult,
    auditResult,
    groupTransactionsResult,
    loansResult,
    notificationsResult,
    memberDetailsResult,
  ] = results;

  const sections = [
    ["members", membersResult],
    ["transaction activity", auditResult],
    ["group transactions", groupTransactionsResult],
    ["loans", loansResult],
    ["notifications", notificationsResult],
    ["member contribution schedule", memberDetailsResult],
  ];

  return {
    members: valueOr(membersResult, []),
    audit: valueOr(auditResult, { statements: [] }),
    groupTransactions: valueOr(groupTransactionsResult, []),
    loans: valueOr(loansResult, []),
    notifications: valueOr(notificationsResult, []),
    memberDetails: valueOr(memberDetailsResult, null),
    failedSections: sections
      .filter(([, result]) => result?.status === "rejected" && result.reason?.name !== "AbortError")
      .map(([section, result]) => ({
        section,
        status: result.reason?.status || null,
        message: result.reason?.message || "Request failed",
      })),
  };
};
